import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'

import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(Vuetify);

import 'vuetify/dist/vuetify.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import * as dl from './dataLoading'


Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify: new Vuetify(),
  render: h => h(App),
  beforeCreate: () => {
    dl.loadData();
  }
}).$mount('#app')
